import { ClickableUpload } from './ClickableUpload';
export default ClickableUpload;
